//import { isAnyOf } from '@reduxjs/toolkit'
import { createAppSlice } from '../../app/createAppSlice'
//import { startAppListening } from '../../app/listenerMiddleware'

const initialState = {
    userId: "",
    name: "",
    userPublicDetail: null,
    userPrivateDetail: null,
    status: "idle"
}

const currentUserSlice = createAppSlice({
    name: "currentUser",
    initialState,
    reducers: create => ({
        userLoggedIn: create.reducer((state, action) => {
            state.userId = action.payload.userId
            state.name = action.payload.name
            state.userPublicDetail = action.payload.userPublicDetail
            state.userPrivateDetail = action.payload.userPrivateDetail
            state.status = "succeeded"
        }),
        userLoggedOut: create.reducer((state) => {
            state.userId = ""
            state.name = ""
            state.userPublicDetail = null
            state.userPrivateDetail = null
            state.status = "idle"
        }),
    }),
    selectors: {
        selectCurrentUserStatus: currentUser => currentUser.status,
        selectCurrentUserError: currentUser => currentUser.error,
        selectCurrentUserId: currentUser => currentUser.userId,
        selectCurrentUserName: currentUser => currentUser.name,
        selectCurrentUserAdmin: currentUser => currentUser.userPrivateDetail?.admin,
        selectCurrentUserApiToken: currentUser => currentUser.userPrivateDetail?.apiToken
    },
})

export const { userLoggedIn, userLoggedOut } = currentUserSlice.actions

export const { selectCurrentUserStatus, selectCurrentUserError,
    selectCurrentUserId, selectCurrentUserName, selectCurrentUserAdmin,
    selectCurrentUserApiToken } = currentUserSlice.selectors
/*
export const addCurrentUserListeners = () => {

    startAppListening({
        matcher: isAnyOf(userLoggedIn, userLoggedOut),
        effect: async (action, listenerApi) => {
            //console.log("currentUser listener was triggered") //Commented out because it was flooding the console
            try {
                const userId = selectCurrentUserId(listenerApi.getState());
                if (userId) {
                    console.log(userId)
                    let user = firebase.auth().currentUser;
                    console.log(user)
                    //await user.getIdToken(true).then(async (storedIdToken) => { idToken = storedIdToken });

                } else {
                    //console.log("This should be triggered by userLoggedOut")  //Commented out because it was flooding the console

                }

            } catch (err) {
                console.log("FAILURE of userLoggedIn/Out: ", err)
            }
        }
    })
}
*/
export default currentUserSlice